import React from 'react'
import InnerHeaderPaySumamry from '../../components/comment/innerHeader/InnnerHeaderIcon'
import Footer from "../../components/footer";
import Header from "../../components/header/index";
import PaySummaryContent from './paysummarycontent/summaryContent';

const paymentsummary = () => {
  return (
    <div className="main">
      <Header />
      <InnerHeaderPaySumamry title="Payment Summary "/>
      <PaySummaryContent />
      <Footer />
    </div>
  )
}

export default paymentsummary